module.exports = "/assets/dist/images/hatchback_wide.jpg?8ad0391e1ddb46a34a14669bd3b75e5e";